import {local} from "./local";
import {dev} from "./dev";
import {staging} from "./staging";
import {prod} from "./prod";
import {Environment} from "./config";

export const QUERY_PARAM_LIMIT = 40;

export const config = (() => {
    switch (process.env.REACT_APP_ENVIRONMENT) {
        case Environment.LOCAL: return local;
        case Environment.DEV: return dev;
        case Environment.STAGING: return staging;
        default: return prod;
    }
})();